import { Observable } from 'rxjs';
import { ProgramModel } from '../../models';

export abstract class BaseProgramUpdateService {
  public abstract updateProgram(program: ProgramModel, values: any): Observable<any>;
}
